export default "__VITE_ASSET__BupGedCG__"